import React, { ReactNode, useMemo, type JSX } from 'react';
import { I18n as I18nType, i18n } from '@lingui/core';
import { I18nProvider as LinguiI18nProvider } from '@lingui/react';

import { Locale } from '@rover/constants/src/i18n/lingui.constants';
import { I18nContextProvider } from '@rover/react-lib/src/context/I18nContext';
import { getDateTimeFormatMapForLocale } from '@rover/utilities/datetime';

export type Props = {
  locale: Locale;
  children: ReactNode;
};

const I18nProvider = ({ locale, children }: Props): JSX.Element => {
  const i18nContextValue = useMemo(() => {
    const DF = getDateTimeFormatMapForLocale(locale);
    return { DF, locale };
  }, [locale]);
  return (
    <LinguiI18nProvider i18n={i18n}>
      <I18nContextProvider value={i18nContextValue}>{children}</I18nContextProvider>
    </LinguiI18nProvider>
  );
};

export type { I18nType };

export default I18nProvider;
